import { myFetch, HttpMethod } from './baseService';

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface Visitante {
  vis_codigo: number;
  vis_foto_nombre?: string;
  vis_unidad_residencial?: string;
  vis_torre?: string;
  vis_torre_nombre?: string;
  vis_apartamento?: string;
  vis_apartamento_nombre?: string;
  vis_nombre_completo?: string;
  vis_tipo_documento?: string;
  vis_tipo_documento_nombre?: string;
  vis_numero_documento?: string;
  vis_ruta_foto?: string;
  vis_estatus?: string;
  vis_estatus_nombre?: string;
  vis_importante?: string;
  vis_nombre?: string;
  vis_celular?: string;
  vis_foto_ruta?: string;
  [key: string]: any;
}

export interface ObtenerVisitantesRequest {
  codigo: string;
  apartamento_codigo: string;
}

export interface ObtenerVisitanteDetalleRequest {
  codigo: string;
  apartamento_codigo: string;
}

export interface IngresarALibroVisitasRequest {
  unidad_residencial: string;
  "torre nombre": string;
  "apartamento nombre": string;
  nombre: string;
  tipo_documento_codigo?: string;
  numero_documento?: string;
  celular?: string;
  "foto nombre"?: string;
}

export const obtenerVisitantes = async (payload: ObtenerVisitantesRequest) => {
  const requestPayload = {
    codigo: String(payload.codigo || ""),
    apartamento_codigo: String(payload.apartamento_codigo || ""),
  };
  
  const envelope = await myFetch<ApiEnvelope<Visitante[]>>(
    'visitante/ObtenerTodos',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

export const obtenerVisitanteDetalle = async (payload: ObtenerVisitanteDetalleRequest) => {
  const requestPayload = {
    codigo: String(payload.codigo || ""),
    apartamento_codigo: String(payload.apartamento_codigo || ""),
  };
  
  // El backend responde con un array en object_, aunque sea un solo visitante
  const envelope = await myFetch<ApiEnvelope<Visitante[]>>(
    'visitante/ObtenerTodos',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

export const ingresarALibroVisitas = async (payload: IngresarALibroVisitasRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'visitante/Ingresa_a_libro_visitas',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

